module.exports = __webpack_public_path__ + "img/1503998084.a965e8a3.jpg";